import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import AuthContext from "../components/auth-context";

import { Login, Order, OrderDetail, Menuchain, Settings } from "../screens";

const ProtectedRoute = ({ auth, component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={() => (auth ? <Component /> : <Redirect to="/" />)}
    />
  );
};

const ProtectedLogin = ({ auth, component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={() => (!auth ? <Component /> : <Redirect to="/order" />)}
    />
  );
};

const Navigation = () => {
  const Auth = React.useContext(AuthContext);

  return (
    <Router>
      <Switch>
        <ProtectedLogin exact path="/" component={Login} auth={Auth.loggedIn} />

        <ProtectedRoute
          exact
          path="/order"
          auth={Auth.loggedIn}
          component={Order}
        />
        <ProtectedRoute
          auth={Auth.loggedIn}
          exact
          path="/orderdetail"
          component={OrderDetail}
        />
        <ProtectedRoute
          exact
          path="/menuchain"
          auth={Auth.loggedIn}
          component={Menuchain}
        />
        <ProtectedRoute
          exact
          path="/settings"
          auth={Auth.loggedIn}
          component={Settings}
        />
      </Switch>
    </Router>
  );
};

export default Navigation;
